import { BookmarkCard } from "../../components/index.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function StoryBookmark(_ref) {
  var {
    node,
    storyOEmbedInfo
  } = _ref;
  return /*#__PURE__*/_jsx(BookmarkCard, {
    hrefId: "story-bookmark-".concat(node.uuid),
    layout: node.layout,
    newTab: node.new_tab,
    showThumbnail: node.show_thumbnail,
    uuid: node.uuid,
    oembed: storyOEmbedInfo,
    className: "prezly-slate-story-bookmark"
  });
}